import { Navigate } from 'react-router-dom';
import { Spinner } from '@design-system';
import { useConsumerPlan } from './hooks/use-consumer-plan';
import { useEndGuidedJourney } from './hooks/use-end-guided-journey';
import { resolveConsumerEntryStep } from './lib/flow-completion';
import { consumerStepPath } from './lib/paths';

/** Sends a consumer to Your Plan once they have finished, otherwise to the first step. */
export function ConsumerFlowEntry({ clientId }: { clientId: string }) {
  const { plan, applications, isLoading } = useConsumerPlan(clientId);
  useEndGuidedJourney(clientId);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner className="size-6" />
      </div>
    );
  }

  return <Navigate to={consumerStepPath(clientId, resolveConsumerEntryStep(plan, applications))} replace />;
}
